import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
const entityNames = (nameList: string[]) => {
  nameList.sort();
  if (nameList.length === 1) {
    return `the ${nameList[0]}`;
  } else {
    const lastName = nameList.pop() as string;
    return `the ${nameList.join(', the ')} and the ${lastName}`;
  }
};
export function OutOfDateMessage(t0) {
  const $ = _c(5);
  const {
    inactiveEntities
  } = t0;
  if (inactiveEntities.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== inactiveEntities) {
    t1 = entityNames(inactiveEntities);
    $[0] = inactiveEntities;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const nameList = t1;
  const message = `This page includes information about ${nameList}, currently unavailable on NerdWallet. The information about ${nameList} has been collected by NerdWallet and has not been provided or reviewed by the card issuer.`;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box sx={{
      marginBottom: 2
    }}><Typography variant="textSmallBold">SOME CARD INFO MAY BE OUTDATED</Typography></Box>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== message) {
    t3 = <Box><Box sx={_temp}><Box>{t2}<Typography variant="textSmall" data-testid="out-of-date-message-content">{message}</Typography></Box></Box></Box>;
    $[3] = message;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(theme) {
  return {
    border: `1px solid ${theme.palette.neutral.light}`,
    borderLeftColor: theme.palette.neutral.light,
    borderRadius: "2px",
    padding: theme.spacing(3)
  };
}